import {axios} from "../../config/axios";

export const attachmentAPI = {
  create(ownerId, label, ownerType, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('label', label);
    formData.append('owner_type', ownerType);
    formData.append('owner_id', ownerId);

    return axios.post('/api/v3/attachments', formData, {
      'Content-Type': 'multipart/form-data'
    }).then((resp) => resp.data);
  },

  delete(uuid) {
    return axios.delete(`/api/v3/attachments/${uuid}`).then((resp) => resp.data);
  },

  storedMMS(ownerType) {
    return axios.get(`/api/v3/attachments/stored_mms`, {
      params: {
        owner_type: ownerType
      }
    }).then((resp) => resp.data);
  },

  attachStoredImageToCampaign(campaignId, imageId) {
    return axios.patch(`/api/v3/attachments/attach_stored_image`, {},{
      params: {
        owner_type: 'Campaign',
        owner_id: campaignId,
        stored_image_id: imageId
      }
    }).then((resp) => resp.data);
  },

  forCampaign(campaignId, params) {
    return axios.get(`/api/v3/campaigns/${campaignId}/campaign_attachments`, {
      params
    }).then((resp) => resp.data);
  },

  forAutocampaign(campaignId, autocampaignId, params) {
    return axios.get(`/api/v3/campaigns/${campaignId}/campaign_attachments/auto_campaign_id=${autocampaignId}`, {
      params
    }).then((resp) => resp.data);
  },

  forReward(rewardId, ownerId, ownerType) {
    return axios.get(`/api/v3/campaign_rewards/${rewardId}/reward_attachments`, {
      params: {
        owner_id: ownerId,
        owner_type: ownerType
      }
    }).then((resp) => resp.data);
  }
}
